module.exports = __webpack_public_path__ + "img/check-mark.ebbaa99b.svg";